import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/FirldTrips/2023/Scienceday/1.jpg';
// import p2 from 'assests/Photos/FirldTrips/2023/Scienceday/2.jpg';
// import p3 from 'assests/Photos/FirldTrips/2023/Scienceday/3.jpg';
// import p4 from 'assests/Photos/FirldTrips/2023/Scienceday/4.jpg';
// import p5 from 'assests/Photos/FirldTrips/2023/Scienceday/5.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar_2023 from '../Sidebar_2023';


const NationalScienceDay2023 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });


    const [config, setConfig] = useState({ base_image_archive_url: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/scienceday/1.webp`;
    const p2 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/scienceday/2.webp`;
    const p3 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/scienceday/3.webp`;
    const p4 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/scienceday/4.webp`;
    const p5 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/scienceday/5.webp`;
  

    const photos = [
       {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
      {
          src: p2,
          source: p2,
          rows: 1,
          cols: 1,
      },
      {
          src: p5,
          source: p5,
          rows: 1,
          cols: 1,
      },
      {
          src: p1,
          source: p1,
          rows: 1,
          cols: 2,
      },
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                ‘Celebrating National Science Day’
                                </Typography>
                                {/* <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 8   Date: 24 FEBRUARY 2024

                                </Typography> */}
                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The National Science Day celebrations at National Public School, Yeshwanthpur, served as a testament to the spirit of curiosity and continuous learning that defines the scientific temperament. The school organised a range of activities aimed at fostering scientific temper, encouraging scientific innovation, and inspiring the younger generation to pursue careers in science and technology. 
                                    <br />
                                    The students of KG-II C delivered an entertaining and amusing assembly on the topic of Aditya L-1, adding humour and hilarity to their presentation. They creatively showcased how scientists conceptualize experimentation and exploration, infusing the audience with laughter while illustrating the process of developing new models for further discoveries.
                                    <br />
                                    Classes 8 and 9 students visited Open Day events at IISc and RRI, touring campuses, interacting with faculty and scholars, and participating in live demos. They explored fields like Nano Science and Aerospace and visited the Raman Museum showcasing CV Raman's crystal collections.
                                    <br />
                                    Students in grades 6 through 8 enthusiastically participated in a wide range of competitions organized by the UR Rao Space Centre (URSC), Visvesvaraya Industrial & Technological Museum, and Raman Research Institute (RRI). They exhibited their skills in various activities such as quizzes, extemporaneous speaking, Science in action, and Elocution, showcasing their dedication to scientific exploration and innovation. Notably, the students excelled in all the mentioned competitions, and emerged victorious in the quiz competition, claiming the top spot.
                                    <br />
                                    The National Science Day events provided an opportunity to every young mind to explore the wonders of the universe and saw enthusiastic participation of budding scientists in science competitions and tinkering sessions. 
                                    <br />
                                </Typography>
                            </Box>
                            {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “Always Looking Up”

                                <br />
                            </Typography> */}


                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                            <Sidebar_2023 />
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default NationalScienceDay2023;